import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";

// Utils
import { EVENT_DATA } from "../utils/event-data";

// Components
import EventCarousel from "../components/EventCarousel";

// Material-UI Components
import { Box, Typography } from "@mui/material";

// Material-UI Icons
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";

export default function EventsPage() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <>
      {EVENT_DATA.map((event, index) => (
        <Box
          data-aos="fade-up"
          key={index}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            flexDirection: "column",
            mb: 20,
          }}
        >
          <Typography
            onClick={() =>
              navigate(
                `${event.event_name.replace(/\s+/g, "-").toLocaleLowerCase()}`
              )
            }
            fontSize="xxx-large"
            fontWeight="bold"
            sx={{
              cursor: "pointer",
              position: "relative",
              width: "fit-content",
              color: "white",
              mb: { xs: 2, sm: 2, md: 6, lg: 6, xl: 6 },
              mt: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.5s ease-in-out",
              "&:hover": {
                textDecoration: "underline",
                "& .icon": {
                  display: "inline-block", // Show the icon on hover
                  transform: "rotate(360deg)", // Rotate the icon
                },
              },
              fontSize: {
                xs: "8vw",
                sm: "6vw",
                md: "6vw",
                lg: "4vw",
                xl: "3vw",
              },
            }}
          >
            {event.event_name}
            <ArrowOutwardRoundedIcon
              className="icon"
              fontSize="xx-large"
              sx={{
                ml: 1,
                transition: "transform 0.5s ease-in-out", // Smooth rotation
              }}
            />
          </Typography>
          <EventCarousel slides={event.data} />
        </Box>
      ))}
    </>
  );
}
